// src/services/api/nflApi.js
import { rootApi } from './rootApi';

export const sportsApi = rootApi.injectEndpoints({
    endpoints: (build) => ({
        getInjuries: build.query({
            query: ({ sport, request_type, ids = null, season = null, week = null, season_type = null }) => ({
                url: '/sports/injuries',
                method: 'POST',
                body: { 
                    sport, 
                    request_type, 
                    ids, 
                    season, 
                    week, 
                    season_type 
                },
            }),
            keepUnusedDataFor: 600, // 10 minutes cache
            providesTags: (result, error, arg) => [{ type: 'Injuries', id: arg.sport.toUpperCase() }],
        }),
        getStandings: build.query({
            query: ({ sport }) => ({
                url: `/sports/standings?sport=${sport}`,
                keepUnusedDataFor: 600, // 10 minutes cache
                providesTags: () => [{ type: 'Standings', id: sport.toUpperCase() }],
            }),
        }),
        getLineups: build.query({
            query: ({ sport, idsArray }) => ({
                url: `/sports/lineups?sport=${sport}&ids=${idsArray.join(',')}`,
                keepUnusedDataFor: 300, // 5 minutes cache
                providesTags: () => [{ type: 'Lineups', id: `${sport.toUpperCase()}-${idsArray.join(',')}` }],
            }),
        }),
        getTeamPlayerStats: build.query({
            query: ({ sport, season, season_type, team_ids }) => ({
                url: `/sports/team-player-stats?sport=${sport}&season=${season}&season_type=${season_type}&team_ids=${team_ids.join(',')}`,
                keepUnusedDataFor: 300, // 5 minutes cache
                providesTags: () => [{ type: 'TeamPlayerStats', id: `${sport.toUpperCase()}-${team_ids.join(',')}` }],
            }),
        }),
        getPlayerGames: build.query({
            query: ({ sport, num_games, player_id, type = null }) => ({
                url: `/sports/player-games?sport=${sport}&num_games=${num_games}&player_id=${player_id}${type ? `&type=${type}` : ''}`,
                keepUnusedDataFor: 60, // 1 minutes cache
                providesTags: () => [{ type: 'PlayerGames', id: `${sport.toUpperCase()}-${player_id}` }],
            }),
        }),
    }),
    overrideExisting: false,
  });
  
  export const { 
    useGetInjuriesQuery,
    useGetStandingsQuery,
    useGetLineupsQuery,
    useGetTeamPlayerStatsQuery,
    useGetPlayerGamesQuery,
  } = sportsApi;